export enum FilingType {
  eForm = 1,
  Scan = 2,
  Upload = 3,
  Legacy = 4,
}

export enum FilingSubmissionStatus {
  Completed = 1,
  Draft = 2,
  Discarded = 3,
  ReadyToSubmit = 4,
  Processing = 5,
  eFormSubmissionError = 6,
}
